import React,{useEffect, useState} from 'react'
import Header from './Header'
import Footer from './Footer'
import StickyRoundyChatNow from './StickyRoundyChatNow'
import { getSiteEnv } from '../services/Utils';
import { GetEnvironmentSettings } from '../services/Api';
import { Route, Routes } from 'react-router-dom';
const Layout = ({ children }) => {
    const layoutStyle = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%"
    }
    const [env,setEnv] = useState(null)
    let envr=""
    const LoadEnv = async () => {
        envr = await GetEnvironmentSettings()
        setEnv(envr)
    }
    useEffect(() => { 
        LoadEnv();
        console.log('update env');
    }, []);
    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, { env,setEnv });
        }
        return child;
      });

    return (
        env&&<div style={layoutStyle}>
            <Header />
            <Routes>
                <Route index element={childrenWithProps} />
            </Routes>
            
            <Footer />
            {/* <StickyRoundyChatNow/> */}
        </div>
    )
}

export default Layout